'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var registerInterfaceWithDefaultTheme = {};

exports.__exports = registerInterfaceWithDefaultTheme;
